import { createAction, props } from '@ngrx/store';
import { CartEntry, ShoppingCartItem } from '@shared-models';

const actionPrefix = '[SHOPPING CART] ';

export const toggleShoppingCartAction = createAction(
  `${actionPrefix} Toggle Shopping Cart`,
  props<{ showCart: boolean }>(),
);

export const togglePaymentSuccessfulAction = createAction(
  `${actionPrefix} Payment Successful`,
  props<{ showMessage: boolean }>(),
);

export const togglePaymentErrorAction = createAction(
  `${actionPrefix} Payment Error`,
  props<{ showMessage: boolean }>(),
);

export const togglePaymentCancelAction = createAction(
  `${actionPrefix} Payment Cancel`,
  props<{ showMessage: boolean }>(),
);

export const addToCartAction = createAction(
  `${actionPrefix} Add To Cart`,
  props<{ cartEntry: CartEntry }>(),
);

export const removeProductFromCartAction = createAction(
  `${actionPrefix} Remove Product from Cart`,
  props<{ date?: string; uniqueId: string }>(),
);

export const updateArticleInCartAction = createAction(
  `${actionPrefix} Update Product in Cart`,
  props<{ item: ShoppingCartItem }>(),
);

export const emptyShoppingCartAction = createAction(
  `${actionPrefix} Empty Shopping Cart`,
);

export const acceptPolicyAction = createAction(
  `${actionPrefix} Accept Policy`,
  props<{ accept: boolean }>(),
);

export const focusAcceptPolicyAction = createAction(
  `${actionPrefix} Focus Accept Policy`,
  props<{ focus: boolean }>(),
);

export const saveShoppingCartIdAction = createAction(
  `${actionPrefix} Save Shopping cart ID`,
  props<{ cartId: string }>(),
);
